import firebase from 'firebase'
import BackendService from './BackendService'
import { loadStripe } from '@stripe/stripe-js';

export default class PaymentService extends BackendService {

  private stripePromise = loadStripe('pk_live_51HKiwYACwSHB8vPF8FGcJwHv8HqdGWuqSJhaAHUSKnMiDGEa318l34fqMdPvGaXsMJg1y9aW72qdvaQoD8ESJBgM00Gdhh4vWf');

  async getCustomerSubscription(uid: string) {
    this.$db.collection('customers')
      .doc(uid)
      .collection('subscriptions')
      .where('status', 'in', ['trialing', 'active'])
      .onSnapshot(async (snapshot: any) => {
        // In this implementation we only expect one active or trialing subscription to exist.
        const doc = snapshot.docs[0];
        console.log(doc.id, ' => ', doc.data());
      });
  }

  async getPricing(): Promise<any> {
    return await this.$db
      .collection('pricing')
      .where('active', '==', true)
      .get()
      .then(async (querySnapshot: any) => {

        // init
        const promises: Promise<any>[] = [];
        const arr: any = [];

        querySnapshot.forEach(async (doc: any) => {

          const item = doc.data();
          item.id = doc.id;
          item.prices = []

          promises.push(
            doc.ref
              .collection('prices')
              .get()
              .then((priceSnap: any) => {
                priceSnap.docs.forEach((doc: any) => {
                  const price = doc.data();
                  price.id = doc.id;
                  item.prices.push(price)
                })
              })
          )
          await arr.push(item);
        });

        await Promise.all(promises)
        return arr;
      })
  }

  async initCheckout(uid: string, companyId: string, priceId: string, url: string) {
    const docRef = await this.$db
      .collection('customers')
      .doc(uid)
      .collection('checkout_sessions')
      .add({
        price: priceId,
        success_url: this.$appUrl + url + '?stripe=success',
        cancel_url: this.$appUrl + url + '?stripe=cancel',
        metadata: {
          companyId: companyId,
        },
      });
    // Wait for the CheckoutSession to get attached by the extension
    docRef.onSnapshot(async (snap: any) => {
      const { sessionId } = snap.data();
      if (sessionId) {
        // We have a session, let's redirect to Checkout
        const stripe = await this.stripePromise;
        if (stripe) {
          await stripe.redirectToCheckout({ sessionId });
        }
      }
    });
  }

  async toCustomerPortal() {
    const functionRef = firebase
      .app()
      .functions('europe-west1')
      .httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink');

    const { data } = await functionRef({ returnUrl: window.location.origin });
    window.location.assign(data.url);
  }
}

export const paymentService = new PaymentService()